module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN321_1908264395.423cc147.png";